import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { ProductDetails, ProductsListResponse, ProductsResponse, ReviewInfo, SingleProduct, SubmitResponse } from "../../models";
import { HttpService } from "./http.service";
import { Observable, catchError, of, shareReplay } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ProductDetail extends HttpService<{ product_ids: (string | number)[] } | string, ProductsListResponse | ProductsResponse | ProductDetails> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'product');
  }
  getAllProducts(page = 1, limit?: number): Observable<ProductsResponse> {
    return this.getAllPaged('', page, '', limit) as Observable<ProductsResponse>;
  }
  getAllAdminProducts(page = 1, limit?: number): Observable<ProductsResponse> {
    return this.getAllPaged('admin', page, '', limit) as Observable<ProductsResponse>;
  }

  getAllFilteredProducts(payload: any): Observable<ProductsResponse> {
    return this.filterAllActionPagedAdmin(payload, 'admin') as Observable<ProductsResponse>;
  }

  getSingleProduct(productId: number): Observable<ProductDetails> {
    return this.getById(productId) as Observable<ProductDetails>;
  }
  deleteProductByID(prodId: number, variantID: number): Observable<SubmitResponse> {
    return this.delete(`/${prodId}/variant/${variantID}`) as Observable<SubmitResponse>;
  }

  deleteProductsInBulk(payload: any): Observable<SubmitResponse> {
    return this.deleteInBulk(payload);
  }
  updateStatus(productId: number, payload: any): Observable<SubmitResponse> {
    return this.patch(productId, payload)
  }
  getProductVariants(productId: number): Observable<ProductsListResponse> {
    return this._getById(productId, '', 'related-product-variants') as Observable<ProductsListResponse>;
  }
  getAddonProductrsByProductId(productId: string): Observable<ProductsListResponse> {
    return this.getAll(productId + '/addon-product-variants') as Observable<ProductsListResponse>;
  }
  getRelatedProductrsByProductId(productId: string, page = 1, limit = 30): Observable<ProductsListResponse> {
    return this.getAllPaged(productId + '/related-product-variants', page, '', limit) as Observable<ProductsListResponse>;
  }
  // getBrandVariants(page: number, brandIdOrSlug = 'apple', limit?: number): Observable<ProductsListResponse> {
  //   // console.log(`getVariants page=${page} categoryIdOrSlug=${categoryIdOrSlug}`);
  //   return this.getAllPaged('brand/' + brandIdOrSlug, page, '', limit) as Observable<ProductsListResponse>;
  // }
  getAllNewArrivalProducts(brandSlug: string, page = 1, limit = 30, lastDays = 100): Observable<ProductsListResponse> {
    return this.getAllNPaged('new-arrival-by-brand/' + brandSlug, page, `last_days=${lastDays}`, limit) as Observable<ProductsListResponse>;
  }
  getAllfeaturedProducts(brandSlug: string, page = 1, limit = 30, lastDays = 100): Observable<ProductsListResponse> {
    return this.getAllNPaged('brands-featured-products/' + brandSlug, page, `last_days=${lastDays}`, limit) as Observable<ProductsListResponse>;
  }
  private brandVariantsCache = new Map<string, Observable<ProductsListResponse>>();

  getBrandVariants(
    page: number,
    brandIdOrSlug = 'apple',
    limit?: number
  ): Observable<ProductsListResponse> {
    const cacheKey = `brand:${brandIdOrSlug}:page:${page}:limit:${limit ?? 'default'}`;

    if (this.brandVariantsCache.has(cacheKey)) {
      return this.brandVariantsCache.get(cacheKey)!;
    }

    const request$ = this.getAllPaged(
      'brand/' + brandIdOrSlug,
      page,
      '',
      limit
    ).pipe(
      shareReplay(1)
    ) as Observable<ProductsListResponse>;

    this.brandVariantsCache.set(cacheKey, request$);

    return request$;
  }

  clearBrandVariantsCache(): void {
    this.brandVariantsCache.clear();
  }

  clearBrandCacheBySlug(brandSlug: string): void {
    Array.from(this.brandVariantsCache.keys()).forEach((key) => {
      if (key.includes(`brand:${brandSlug}:`)) {
        this.brandVariantsCache.delete(key);
      }
    });
  }

}